import React, { useEffect, useRef, useState } from "react";
import Quill from "quill";
import { SnowTheme } from "quill-color-picker-enhance";
import "quill/dist/quill.snow.css"; // Import default Quill snow theme CSS
import "quill-color-picker-enhance/dist/index.css"; // Import the custom color picker styles
import { getImageURL } from "../../_helper/utils/image";

// Register the custom Snow theme
Quill.register("themes/snow-quill-color-picker-enhance", SnowTheme);

function insertAtCursor(quill, getVal, cursorPosition) {
  if (cursorPosition != null) {
    quill.insertText(cursorPosition, `@${getVal}`);
    quill.setSelection(cursorPosition + getVal.length + 1);
  }
}

export default function CertificateEditor({
  header_footer_setup_data,
  getVal,
  triggerFunc,
  setsendEditorContent,
  geteditorContent,
}) {
  const editorRef = useRef(null); // Reference for the editor container
  const quillRef = useRef(null); // Reference to store the Quill instance
  const [editorContent, setEditorContent] = useState(""); // State to hold the editor content
  const [cursorPosition, setCursorPosition] = useState(null); // State to store the cursor position

  // Effect to update the editor content when `geteditorContent` changes
  useEffect(() => {
    const quill = quillRef.current;

    if (quill && geteditorContent && quill.clipboard) {
      // Ensure the Quill instance and clipboard are available
      quill.clipboard.dangerouslyPasteHTML(geteditorContent);
      quill.setSelection(geteditorContent.length);
    }
  }, [geteditorContent]);

  useEffect(() => {
    handleInsertGetVal();
  }, [triggerFunc]);

  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      const quill = new Quill(editorRef.current, {
        theme: "snow-quill-color-picker-enhance",
        modules: {
          toolbar: {
            container: [
              [{ font: [] }, { size: [] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              ["clean"],
            ],
          },
        },
        placeholder: "Write Certificate Body here",
      });

      quillRef.current = quill;

      // Set the initial content if present
      if (geteditorContent) {
        quill.clipboard.dangerouslyPasteHTML(geteditorContent);
        quill.setSelection(geteditorContent.length);
        setEditorContent(geteditorContent); // Explicitly set initial content
        setsendEditorContent(geteditorContent); // Send initial content upwards
      }

      // Listen for changes in the editor content
      quill.on("text-change", () => {
        const content = quill.root.innerHTML; // Get the updated content
        setEditorContent(content); // Update the state
        setsendEditorContent(content); // Send updated content upwards
      });

      // Track cursor position when selection changes
      quill.on("selection-change", (range) => {
        if (range) {
          setCursorPosition(range.index); // Store the cursor position when selection changes
        }
      });
    }
  }, [geteditorContent]);

  // Handler to insert `@getVal` at the last known cursor position
  const handleInsertGetVal = () => {
    if (quillRef.current && cursorPosition !== null) {
      insertAtCursor(quillRef.current, getVal, cursorPosition);
    }
  };

  return (
    <div className="w-[62%]">
      {header_footer_setup_data?.headerUrl ? (
        <img
          className="w-[100%]"
          src={getImageURL(header_footer_setup_data?.headerUrl)}
        />
      ) : (
        <p className="flex justify-center">
          Not getting header if not please set it from header footer setup!
        </p>
      )}

      <div ref={editorRef} className="h-full" id="editor-container" />

      <div className="flex justify-end"></div>

      <div className="flex justify-end">
        {header_footer_setup_data?.printSignature &&
        header_footer_setup_data?.signatureImg ? (
          <img src={getImageURL(header_footer_setup_data?.signatureImg)} />
        ) : (
            <p className="flex justify-center">
              Not getting header if not please set it from header footer setup!
            </p>
          ) || header_footer_setup_data?.signatureText ? (
          header_footer_setup_data?.signatureText
            ?.split("\n")
            .map((line, index) => <div key={index}>{line}</div>)
        ) : (
          <p className="flex justify-center">
            Not getting header if not please set it from header footer setup!
          </p>
        )}
      </div>

      {header_footer_setup_data?.footerURL ? (
        <img
          className="w-[100%]"
          src={getImageURL(header_footer_setup_data?.footerURL)}
        />
      ) : (
        <p className="flex justify-center">
          Not getting Footer if you need so, please set it from header footer
          setup!
        </p>
      )}
    </div>
  );
}
